import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { CarouselCarouselItemComponent } from '@twisto/api-cms/generated-types'

import { Media } from '../../article-components'

import * as styles from './carousel.styles'

export const CarouselItem = ({
  title,
  image,
}: CarouselCarouselItemComponent) => (
  <article css={styles.article}>
    <picture css={styles.picture}>
      <Media src={image} />
    </picture>

    <Typography css={styles.headline} variant="h3">
      {title}
    </Typography>
  </article>
)
